import { render } from "./quick_filter_settings.vue?vue&type=template&id=43207d13"
import script from "./quick_filter_settings.js?vue&type=script&lang=js"
export * from "./quick_filter_settings.js?vue&type=script&lang=js"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__